import { concatUrl } from './base'
import { appRequest } from './request'
import { encrypt } from '@gyasset/shared/utils';

const checkUsernameUrl = concatUrl('/regist/validate/username')

export async function checkUsername (username) {
  const body = new FormData()
  body.append('username', username)
  const result = appRequest(checkUsernameUrl, {
    method: 'POST',
    body
  })
  return result
}

const customerinfoUrl = concatUrl('/regist/validate/customerinfo')

export async function checkCustomerInfo (idtype, idno, mobile, name) {
  const body = new FormData()
  body.append('idtype', idtype)
  body.append('idno', idno)
  body.append('mobile', mobile)
  body.append('name', name)
  const result = appRequest(customerinfoUrl, {
    method: 'POST',
    body
  })
  return result
}

const checkIdnoUrl = concatUrl('/regist/validate/idno')

export async function checkIdno (idtype, idno) {
  const body = new FormData()
  body.append('idtype', idtype)
  body.append('idno', idno)
  const result = appRequest(checkIdnoUrl, {
    method: 'POST',
    body
  })
  return result
}

const checkMobileUrl = concatUrl('/regist/validate/mobile')

export async function checkMobile (mobile) {
  const body = new FormData()
  body.append('mobile', mobile)
  const result = appRequest(checkMobileUrl, {
    method: 'POST',
    body
  })
  return result
}

const registValidate1mobileMsgUrl = concatUrl('/regist/validate/mobileMsg')

export async function registValidateMsgCode (mobile, code) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('code', code)
  const result = appRequest(registValidate1mobileMsgUrl, {
    method: 'POST',
    body,
  })
  return result
}

const registUrl = concatUrl('/regist')

/**
 *
 * @param {object} options
 {
   "username": "yzdytm",
   "password": "12345678",
   "password_confirm": "12345678",
   "mobile": "18612444099",
   "mobile_message": "273487",
   "id_type": "0",
   "id_no": "230206199009031317",
   "customer_name": "易天明",
   "employer": ""
   "customer_email": "yzdytm@163.com"
 }
 */
export async function regist (options) {
  console.log({ ...options })
  const body = JSON.stringify(options)
  const result = appRequest(registUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

//一键注册 接口
const saveQuicklyRegisterPostUrl = concatUrl('/regist/saveQuicklyRegist ')
export async function saveQuicklyRegisterPost ({clientId,password,mobile, mobile_disclosure_agree}) {
  password = encrypt.md5(password)
  const body = JSON.stringify({
    "client_id": clientId,
    'password': password,
    'mobile': mobile,
    'mobile_disclosure_agree': mobile_disclosure_agree
  })
  const result = appRequest(saveQuicklyRegisterPostUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}


const mobileRegistUrl = concatUrl('/regist/mobile')
export async function mobileRegist (options) {
  const newParams = {...options}
  newParams.password = encrypt.md5(newParams.password)
  const body = JSON.stringify(newParams)
  const result = appRequest(mobileRegistUrl, {
    method: 'POST',
    body,
    headers: { 'Content-Type': 'application/json' }
  })
  return result
}

// 找回密码
export async function retrievePassword (obj) {
  let {
    phone, // 手机号
    code, // 短信验证码
    name, // 姓名
    idno, // 证件号码
    type, // 证件类型
    state,
    customerType,
    password,
    otherIdType
  } = obj
  let url,param
  switch (state) {
    case 1:
      param ={customer_type: customerType, name, idno, type,state,other_id_type: otherIdType}
      break
    case 2:
      param ={customer_type: customerType, name,idno,type,phone,code,state,other_id_type: otherIdType}
      break
    case 3:
      password = encrypt.md5(password)
      param ={customer_type: customerType, name,idno,type,phone,code,password,state,other_id_type: otherIdType}
      break
  }
  url = concatUrl(`/regist/retrievePassword/`)
  const result = await appRequest(url, {
    method: 'POST',
    body: JSON.stringify({...param}),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
  return result
}
